import React from 'react';
import {Button} from '@mui/material';
import Typography from '@mui/material/Typography';
import ETVTable from "../tools/ETVTable";
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
import ApartmentIcon from '@mui/icons-material/Apartment';
import BuildIcon from '@mui/icons-material/Build';
import EditIO from './EditIO';
import EditFloorNames from './EditFloorNames';
import FloorSounds from './FloorSounds';
import FloorImages from './FloorImages';
import SettingsIcon from '@mui/icons-material/Settings';
import GeneralElevatorConfig from './GeneralElevatorConfig';
import SelectAvailableScreensNew from '../contentmgmt/SelectAvailableScreensNew';
import SkillsDefinition from './SkillsDefinition';
import ErrorHandling from './ErrorHandling';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import * as ETVConstants from '../ETVConstants';
import ETVPage from '../tools/ETVPage';
import ETVPopup from '../tools/ETVPopup';
import ETVMessagePopup from '../tools/ETVMessagePopup';
import ETVActionButton from '../tools/ETVActionButton';

class ElevatorMgmt extends React.Component {

	constructor(props) {
      	super(props);
		this.closeHook = this.closeHook.bind(this);
		this.selectedScreensHook = this.selectedScreensHook.bind(this);
		this.closeAddressFunction = this.closeAddressFunction.bind(this);
		this.skillsDefinitionRef = React.createRef();
		this.generalElevatorConfigRef = React.createRef();
		this.editIORef = React.createRef();
		this.editFloorNamesRef = React.createRef();
    }

    state = {
      	screen_items:[],
      	isLoaded: false,
		isLoading: false,
		device_id: undefined,
		device_name:'',
		sw_version: 0,
		window:undefined,
		info_message:'',
		info_title:'',
		info_type:'info',
		spinning:false,
		device_skills:[],
		available_skills:[],
		device_skills_changed:false,
		defined_skills_changed:false,
		device_config:{},
		sensor_data:{},
		selected_screens:[],
    }


	componentDidUpdate() {
	    if(!this.state.isLoaded && !this.state.isLoading) {
        	this.loadItems();
      	}
	}

    componentDidMount() {
      	this.loadItems();
		this.loadAvailableSkills();
    }

    loadItems() {
		if(this.state.isLoading) return;
		this.setState({isLoading:true, error:undefined});
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		//var url = ETVConstants.getServerBase()+"/device_mgmt?action=list&owner_id="+this.props.user_id;
		var url = ETVConstants.getServerBase()+"/device_mgmt?action=list_all_devices&owner_id="+this.props.user_id+"&device_type=0";
		//console.log("url="+url);
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
		.then((result) => {
			if(!result || !Array.isArray(result.list)) {
				throw new Error(result?.error || result?.reason || "Unable to load devices");
			}
            //console.log("items="+result.list.length);
            this.setState({
			  	screen_items: this.filterDeviceType(result.list,0).sort((a, b) =>
					(a.device_name || '').localeCompare(b.device_name || '', undefined, { sensitivity: 'base' })
				),
              	isLoaded: true,
				isLoading: false,
            });
		  })
		.catch((error) => {
            this.setState({
              	screen_items:[],
			  	isLoaded: true,
				isLoading: false,
              	error
            });
		})
    }

	filterDeviceType( items, deviceType) {
		var result = [];
		for(var i=0; i<items.length; i++) {
			if(items[i].device_type===deviceType) {
				result.push(items[i]);
			}
		}
		return result;
	}

    showWindow(divID, show) {
      show?this.setState({window:divID}):this.setState({window:''});
    }

	showInfoMessage(title, msg, isSpinning) {
		this.setState({window:'message_div', info_type:'info', info_title:title, info_message:msg, spinning:!!isSpinning});
	}

	showSuccessMessage(title, msg) {
		this.setState({window:'message_div', info_type:'success', info_title:title, info_message:msg, spinning:false});
	}

	showErrorMessage(title, msg) {
		this.setState({window:'message_div', info_type:'error', info_title:title, info_message:msg, spinning:false});
	}

	closeInfoMessage(msg) {
		this.setState({window:'', info_title:'', info_message:'', info_type:'info', spinning:false});
	}

    getItem( deviceID) {
      for(var i=0; i<this.state.screen_items.length; i++) {
        if(this.state.screen_items[i].id===deviceID) {
          return this.state.screen_items[i];
        }
      }
      return undefined;
    }

	editIO( deviceID, swVersion) {
		this.showWindow("edit_io_div",true);
		this.setState({device_id:deviceID, sw_version:swVersion});
	}

	editFloorNames( deviceID, swVersion) {
		this.showWindow("floor_name_div",true);
		this.setState({device_id:deviceID, sw_version:swVersion});
	}

	editSounds(deviceName, deviceID, swVersion) {
		this.showWindow("floor_sounds_div",true);
		this.setState({device_name:deviceName, device_id:deviceID, sw_version:swVersion});
	}

	editFloorImages( deviceID, swVersion) {
		this.showWindow("floor_images_div",true);
		this.setState({device_id:deviceID, sw_version:swVersion});
	}

	editGeneralConfig( deviceID, swVersion, deviceName) {
		this.showWindow("general_elevator_config_div",true);
		this.setState({device_id:deviceID, device_name:deviceName, sw_version:swVersion});
	}

	copyConfigView(deviceID) {
		this.showWindow("copy_config_view",true);
		this.setState({device_id:deviceID,selected_screens:[]});
	}

	closeHook() {
		this.showWindow("copy_config_view",false);
	}

	selectedScreensHook( screens) {
		if(!screens || screens.length===0) {
			this.setState({selected_screens:[]})
			return;
		}
		this.setState({selected_screens:screens});
		//console.log("selected_screens="+screens);
		this.showWindow("copy_config_view",false);
		this.showInfoMessage(ETVConstants.trans("configuration"), 'copy config ... ', true);
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/elevator_config?action=copy_config&device_id="+this.state.device_id;
		for(var i=0; i<screens.length; i++) {
			url += "&target_device="+screens[i];
		}
		//console.log(url);
	    fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then(
          (result) => {
            //console.log(JSON.stringify(result));
						this.showSuccessMessage(ETVConstants.trans("configuration"), "success");
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
						this.showErrorMessage(ETVConstants.trans("configuration"), "error");
						//console.log("error");
          }
        )
    }

	deleteDevice( deviceID) {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/device_mgmt?action=delete_device&device_id="+deviceID;
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
			.then(res => res.json())
			.then(
				(result) => {
					this.setState({
						isLoaded: false,
						showDeleteConfirmDialog: false,
						deleteDeviceID: '',
					});
				},
				(error) => {
				}
			)
	}

	checkCanSave() {
		//console.log("check can save");
		if(!this.state.new_device_id || this.state.new_device_id.length===0) {
			this.setState({canSave:false,txt_error_info:'device id required'});
			return false;
		}
		if(!this.state.new_device_name || this.state.new_device_name.length===0) {
			this.setState({canSave:false,txt_error_info:'device name required'});
			return false;
		}
		this.setState({canSave:true,txt_error_info:''});
		return true;
	}

	closeAddressFunction(needReload) {
		this.showWindow("xxx",false);
		if(needReload) {
			this.setState({isLoaded:false,selected_device:''});
		}
	}

////////////////////////////////////////////////////////////////////////////////
// load skills
////////////////////////////////////////////////////////////////////////////////

	loadAvailableSkills() {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var urlStr = ETVConstants.getServerBase()+"/useradmin?action=get_skills&user_id="+this.props.user_id;
		fetch(urlStr,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then(
			(result) => {
				//console.log("userID="+this.props.user_id+" skills available="+JSON.stringify(result));
				this.setState({
					available_skills: result.skills,
				});
			},
			(error) => {
				this.setState({
					available_skills: [],
					error
				});
			}
		)
	}

	loadDeviceSkills(deviceID) {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var url = ETVConstants.getServerBase()+"/device_mgmt?action=get_skills&device_id="+deviceID;
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
			.then(res => res.json())
			.then(
				(result) => {
					//console.log(JSON.stringify(result));
					this.setState({device_skills:result.skills});
				},
				(error) => {
					//console.log(error);
				}
			)
	}

	showRequiredDeviceSkills( deviceID) {
		this.setState({device_id:deviceID,device_skills_changed:false});
		this.showWindow("device_skills_div",true);
		this.loadDeviceSkills(deviceID);
	}

	formatLocalDate( time) {
		if(!time) return ""; //happens at startup
		var d = new Date(time.replace(/-/g, "/"));
		return d.toLocaleString();
	}

	createTableRow(key,value) {
		//console.log("key="+key+" val="+value);
		return (<TableRow>
						<TableCell><Typography color='primary'>{key}</Typography></TableCell>
						<TableCell><Typography color='primary'>{value}</Typography></TableCell>
						</TableRow>)
	}

	printSensorData() {
		if(!this.state.sensor_data) return (<span>no data available</span>);
		//var deviceID = this.state.sensor_data["device_id"];
		var dateStr = this.formatLocalDate(this.state.sensor_data["last_update"]);
		var data = this.state.sensor_data["data"];
		if(!data) return (<span>no data available</span>)
		return(
			<div>
				<TableContainer component={Paper}>
					<Table sx={{ minWidth: 60 }}>
						<TableBody>
							<TableRow>
								<TableCell><Typography color='secondary'>last update</Typography></TableCell>
								<TableCell><Typography color='secondary'>{dateStr}</Typography></TableCell>
							</TableRow>
							{Object.entries(data).map( ([key,value]) => { return( this.createTableRow(key,value)) })}
						</TableBody>
					</Table>
				</TableContainer>
			</div>
		)
	}

	handleCheckBoxChange( item ) {
		var curSkills = this.state.device_skills;
		if(curSkills.includes(item)) {
				var index = curSkills.indexOf(item);
				curSkills.splice(index,1);
		}else{
			curSkills.push(item);
		}
		this.setState({device_skills_changed:true,device_skills:curSkills});
	}

	printRequiredDeviceSkills() {
		if(!this.state.device_id) return <span/>;
		if(!this.state.device_skills) return <span>no skills</span>;
		return (
			this.state.available_skills.map( (item,index)=> {return <FormControlLabel id={index} key={index} control={<Checkbox checked={this.hasSkill(item)} onClick={()=>this.handleCheckBoxChange(item)}>{item}</Checkbox>} name={item} label={item} />})
		)
	}

	hasSkill( skill) {
		return this.state.device_skills.includes(skill);
	}

	saveDeviceSkills() {
		var url = ETVConstants.getServerBase()+"/device_mgmt?action=set_skills&device_id="+this.state.device_id;
		for(var i=0; i<this.state.device_skills.length; i++) {
			url += "&skill="+encodeURIComponent(this.state.device_skills[i]);
		}
		this.sendCMDToServer(url);
		this.setState({device_skills_changed:false});
	}

	sendCMDToServer(url) {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
			.then((response) => response.json())
			.then((responseJson) => {
					this.setState({
						isLoaded: false
					})
			})
			.catch((error) => {
					console.error(error);
			});
	}

////////////////////////////////////////////////////////////////////////////////
// error handling
////////////////////////////////////////////////////////////////////////////////

	showErrorHandling( deviceID) {
		this.setState({device_id:deviceID});
		this.showWindow("error_handling_div",true);
	}


////////////////////////////////////////////////////////////////////////////////
//
////////////////////////////////////////////////////////////////////////////////

    render() {

	    const columnsDataScreen= [
		  	{ title: 'Last connect', field: 'last_connected', render: rowData => (<div style={{width: "15px", maxWidth:"30px", paddingLeft: "3px"}}> {ETVConstants.getLastConnectSymbol(rowData.last_connected,rowData.startup_datetime,rowData.status)} </div>) },
          	{ title: 'Device Name', field: 'device_name', render: rowData => (<div style={{minWidth: "200px", paddingLeft: "10px"}}> {rowData.device_name} </div>) },
			{ title: 'General Config', field: 'config', render: rowData => <IconButton variant='contained' color='primary' onClick={()=>this.editGeneralConfig(rowData.id, rowData.sw_version, rowData.device_name)}><SettingsIcon/></IconButton>},
			{ title: 'I/O Config', field: 'define_io', render: rowData => <IconButton variant='contained' color='primary' onClick={()=>this.editIO(rowData.id, rowData.sw_version )}><SettingsInputComponentIcon/></IconButton>},
			{ title: 'Floor Mapping', field: 'define_floors', render: rowData => <IconButton variant='contained' color='primary' onClick={()=>this.editFloorNames(rowData.id, rowData.sw_version)}><ApartmentIcon/></IconButton>},
			{ title: 'Sounds Config', field: 'define_sounds', render: rowData => <IconButton variant='contained' color='primary' onClick={()=>this.editSounds(rowData.device_name, rowData.id, rowData.sw_version)}><VolumeDownIcon/></IconButton>},
			{ title: 'Floor Images', field: 'define_floor_img', render: rowData => <IconButton variant='contained' color='primary' onClick={()=>this.editFloorImages(rowData.id, rowData.sw_version)}><ImageIcon/></IconButton>},
			{ title: 'skills', field: '', render: rowData => <IconButton variant='contained' color='primary' onClick={()=>this.showRequiredDeviceSkills(rowData.id)}><BuildIcon/></IconButton>},
			{ title: 'error handling', field: '', render: rowData => <IconButton variant='contained' color='primary' onClick={()=>this.showErrorHandling(rowData.id)}><EditIcon/></IconButton>},
			{ title: 'copy', field: '', render: rowData => <Button variant='contained' color='primary' onClick={()=>this.copyConfigView(rowData.id)}>copy</Button>},
        ];


	  const sortedScreens=[...(this.state.screen_items || [])].sort((a,b)=>String(a.device_name || '').localeCompare(String(b.device_name || ''),undefined,{numeric:true,sensitivity:'base'}));
	  return(
			<ETVPage width="wide" icon={<ApartmentIcon fontSize="large"/>} title="Elevators" description="Manage elevator screens and their configuration." loading={!this.state.isLoaded || this.state.isLoading}
				topActions={<Button variant="contained" startIcon={<BuildIcon/>} onClick={()=>this.showWindow('define_skills',true)}>Define Skills</Button>}>
				<ETVTable data={sortedScreens} columns={columnsDataScreen} title="Elevator screens" pageSize={20} search={true}/>


				<ETVPopup
					open={this.state.window==='edit_io_div'}
					width="standard" onClose={()=>this.showWindow('edit_io_div',false)} icon={<SettingsInputComponentIcon/>} title="Edit I/O"
					description="Configure elevator input and output mappings."
					topActions={<Button variant="contained" onClick={()=>this.editIORef.current?.setDefault()}>Set Default</Button>}
					bottomActions={<>
						<ETVActionButton action="cancel" label="Close" onClick={()=>this.showWindow('edit_io_div',false)}/>
						<ETVActionButton action="save" onClick={()=>this.editIORef.current?.saveIO()}/>
					</>}>
						{this.state.window==='edit_io_div'?<EditIO ref={this.editIORef} device_id={this.state.device_id} sw_version={this.state.sw_version} />:<span/>}
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='copy_config_view'}
					width="wide" onClose={()=>this.showWindow('copy_config_view',false)} icon={<ApartmentIcon/>} title="Copy configuration"
					description="Choose the elevator screens that should receive this configuration."
					bottomActions={<ETVActionButton action="cancel" label="Close" onClick={()=>this.showWindow('copy_config_view',false)}/> }>
							{(this.state.window==='copy_config_view')?<SelectAvailableScreensNew isOpen={this.state.window==='copy_config_view'} user_id={this.props.user_id} closeHook={this.closeHook} excluded_screen_ids={[this.state.device_id]} selectedScreens={this.selectedScreensHook} selected={this.state.selected_screens?this.state.selected_screens:[]}/>:<span/>}
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='floor_name_div'}
					width="standard" onClose={()=>this.showWindow('floor_name_div',false)} icon={<ApartmentIcon/>} title="Edit floor names"
					description="Configure the floor labels shown by this elevator screen."
					bottomActions={<>
						<ETVActionButton action="cancel" label="Close" onClick={()=>this.showWindow('floor_name_div',false)}/>
						<ETVActionButton action="save" onClick={()=>this.editFloorNamesRef.current?.saveMapping()}/>
					</>}>
							{this.state.window==='floor_name_div'?<EditFloorNames ref={this.editFloorNamesRef} device_id={this.state.device_id} />:<span/>}
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='general_elevator_config_div'}
					width="wide" onClose={()=>this.showWindow('general_elevator_config_div',false)} icon={<SettingsIcon/>} title={ETVConstants.trans("configuration")}
					description="Configure the general elevator behavior for this screen."
					topActions={<Button variant="contained" onClick={()=>this.generalElevatorConfigRef.current?.setDefault()}>Set Default</Button>}
					contentSx={{maxHeight:'calc(100vh - 230px)'}}
					bottomActions={<>
						<ETVActionButton action="cancel" label="Close" onClick={()=>this.showWindow('general_elevator_config_div',false)}/>
						<ETVActionButton action="save" onClick={()=>this.generalElevatorConfigRef.current?.saveConfig()}/>
					</>}>
							{this.state.window==='general_elevator_config_div'?<GeneralElevatorConfig ref={this.generalElevatorConfigRef} device_id={this.state.device_id} device_name={this.state.device_name} sw_version={this.state.sw_version} />:<span/>}
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='floor_sounds_div'}
					width="wide" onClose={()=>this.showWindow('floor_sounds_div',false)} icon={<VolumeDownIcon/>} title="Manage floor sounds"
					description="Assign audio announcements to elevator floors."
					bottomActions={<ETVActionButton action="cancel" label="Close" onClick={()=>this.showWindow('floor_sounds_div',false)}/> }>
							{this.state.window==='floor_sounds_div'?<FloorSounds device_name={this.state.device_name} device_id={this.state.device_id} />:<span/>}
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='floor_images_div'}
					width="wide" onClose={()=>this.showWindow('floor_images_div',false)} icon={<ImageIcon/>} title="Manage floor images"
					description="Assign images to elevator floors."
					bottomActions={<ETVActionButton action="cancel" label="Close" onClick={()=>this.showWindow('floor_images_div',false)}/> }>
							{this.state.window==='floor_images_div'?<FloorImages device_id={this.state.device_id} />:<span/>}
				</ETVPopup>

				<ETVMessagePopup
					open={this.state.window==='message_div'}
					type={this.state.spinning?'progress':this.state.info_type}
					allowClose={!this.state.spinning}
					onClose={()=>{this.closeInfoMessage()}}
					title={this.state.info_title}
					message={this.state.info_message}
				/>

				<ETVPopup
					open={this.state.window==='define_skills'}
					width="small" onClose={()=>this.showWindow('define_skills',false)} icon={<BuildIcon/>} title={ETVConstants.trans("define_skills")}
					description="Define the available elevator device capabilities."
					bottomActions={<><ETVActionButton action="cancel" label="Close" onClick={()=>this.showWindow('define_skills',false)}/><ETVActionButton action="save" disabled={!this.state.defined_skills_changed} onClick={()=>this.skillsDefinitionRef.current?.saveAvailableSkillSet()}/></>}>
						<SkillsDefinition ref={this.skillsDefinitionRef} user_id={this.props.user_id} onChanged={(changed)=>this.setState({defined_skills_changed:changed})}/>
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='sensor_data_div'}
					width="small" onClose={()=>this.showWindow('sensor_data_div',false)} icon={<SettingsInputComponentIcon/>} title="Sensor data"
					description="Current raw elevator sensor values."
					bottomActions={<ETVActionButton action="cancel" label="Close" onClick={()=>this.showWindow('sensor_data_div',false)}/> }>
								{this.printSensorData()}
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='device_skills_div'}
					width="small" onClose={()=>this.showWindow('device_skills_div',false)} icon={<BuildIcon/>} title={ETVConstants.trans("required_device_skillset")}
					description="Choose the capabilities required by this elevator screen."
					bottomActions={<><ETVActionButton action="cancel" onClick={()=>this.showWindow('device_skills_div',false)}/><ETVActionButton action="save" disabled={!this.state.device_skills_changed} onClick={()=>this.saveDeviceSkills()}/></>}>
						{this.printRequiredDeviceSkills()}
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='error_handling_div'}
					width="standard" onClose={()=>this.showWindow('error_handling_div',false)} icon={<EditIcon/>} title={ETVConstants.trans("error_handling")}
					description="Configure how elevator error states are detected and handled."
					bottomActions={<ETVActionButton action="cancel" label="Close" onClick={()=>this.showWindow('error_handling_div',false)}/> }>
						<ErrorHandling device_id={this.state.device_id} user_id={this.props.user_id} />
				</ETVPopup>

	</ETVPage>
	);
	}
}

export default ElevatorMgmt
